<template>
  <div class="content-box">
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">
          Solicitudes Pendientes de autorización
          <span class="text-success"> &nbsp;&nbsp;&nbsp;&nbsp; Tienda:</span>
          &nbsp;
          <span class="text-success">{{ filter.tienda.nombre }}</span>
        </h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12">
              <div class="row justify-content-sm-end">
                <div class="form-inline justify-content-sm-end">
                  <button
                    type="button"
                    @click="modalTiendaSelect"
                    class="btn btn-dark btn-md"
                  >
                    Cambiar Tienda
                    <i class="fas fa-history"></i>
                  </button>
                  <button
                    type="button"
                    @click="abrirModalRecepcion()"
                    class="btn btn-success btn-md"
                  >
                    Autorizar una recepción completa
                    <i class="fas fa-check"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-------------------- END - Controles arriba de tabla-------------------->
        <div class="table-responsive">
          <!-------------------- Tabla de REsultados -------------------->
          <table class="table table-hover">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Cantidad</th>
                <th>Tarima</th>
                <th>Usuario</th>
                <th>Estado</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="current in data.results"
                v-bind:key="current.id"
                @click="modaldetalle(current)"
              >
                <td>{{ current.producto }}</td>
                <td>{{ current.cantidad }}</td>
                <td>{{ current.tarima }}</td>
                <td>{{ current.usuario }}</td>
                <td>{{ current.estado_str }}</td>
                <td></td>
              </tr>
            </tbody>
          </table>
          <!-------------------- END - Basic Table -------------------->
        </div>
        <PaginationComponent
          :currentPage="currentPage"
          :data="data"
          @pagechanged="filterData"
        />
      </div>
    </div>
    <div
      class="modal fade"
      id="modalTiendaSelect"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Elije una tienda
            </h5>
          </div>
          <div class="modal-body">
            <select
              class="form-control col-12"
              v-model="filter.tienda"
              @change="refreshtienda()"
            >
              <option v-for="(item, key) in tiendas" :value="item" :key="key">
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="clearFilterData()"
            >
              Cerrar
            </button>
            <!--☦-->
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="buscarRecepcion"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLongTitle"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">
              Busca Recepción
            </h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-12">
                <label>Número</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="filter.numero"
                />
              </div>
              <div class="col-12">
                <br />
                <button
                  @click="buscarRecpcion()"
                  class="btn btn-success btn-block"
                >
                  Buscar <i class="fas fa-search"></i>
                </button>
              </div>
              <table class="table table-striped table-hover">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Tienda</th>
                    <th>Barra</th>
                    <th>Fecha creación</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    @click="autorizarTodasLasLineas(detalle)"
                    v-for="detalle in recepciones"
                    :key="detalle.id"
                  >
                    <td>{{ detalle.numero }}</td>
                    <td>{{ detalle.tienda }}</td>
                    <td>{{ detalle.proveedor }}</td>
                    <td>{{ detalle.fecha_creacion }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="clearFilterData()"
            >
              Cerrar
            </button>
            <!--☦-->
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="modalDetalle"
      tabindex="-1"
      role="dialog"
      aria-labelledby="modalDetalle"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">
              Opciones de Linea
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <button
              @click="autorizarLinea(current)"
              class="btn btn-success btn-block"
            >
              Autorizar Linea
            </button>
            <button
              @click="eliminar_autorizacion(current)"
              class="btn btn-danger btn-block"
            >
              Eliminar Linea
            </button>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import ProductosService from "@/services/catalogos/ProductosService";
import DynamicService from "@/services/commons/DynamicService";
import Notifications from "@/notifications/notifications";
import { mapGetters } from "vuex";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      mostrarRefresh: false,
      current: {},
      recepciones: [],
      currentPage: 1,
      searchtext: "",
      filter_activo: "",
      data: [],
      filter: {
        tienda: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
      dataTabla1: "cotizaciones/cotizaciones",
      dataTabla: "ordencompra/orden_compras",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    $("#modalTiendaSelect").modal("show");
  },
  methods: {
    abrirModalRecepcion() {
      $("#buscarRecepcion").modal("show");
    },
    buscarRecpcion() {
      let self = this;
      DynamicService.fetch("wms", "recepcion", {
        barra: this.filter.barra,
        numero: this.filter.numero,
      }).then((response) => {
        console.log(response.data);
        self.recepciones = response.data.results;
      });
    },
    autorizarTodasLasLineas(det) {
      let self = this;
      Notifications.alert.confirm(
        "¿Autorizar todas las lineas de la recpción seleccionada?",
        "Esto afectara todas las recpción por esta tienda",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "recepcion",
            det.id,
            "autorizar_detalle_lineas"
          )
            .then((response) => {
              Notifications.alert.success(
                "Autorizar Linea Recepción",
                "Se realizó correctamente"
              );
              $("#buscarRecepcion").modal("hide");
              self.filterData();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Autorizar Linea Recepción",
                error.response.data.detail
              );
            });
        }
      );
    },
    modaldetalle(current) {
      $("#modalDetalle").modal("show");
      this.current = current;
    },
    modalTiendaSelect() {
      $("#modalTiendaSelect").modal("show");
    },
    filterData(page) {
      let self = this;
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("wms", "detalle_autorizar", {
        page: page,
        tienda: this.filter.tienda.codigo,
      }).then((res) => {
        self.data = res.data;
        $("#modalTiendaSelect").modal("hide");
      });
    },
    refreshtienda() {
      this.data = "";
      this.currentPage = 1;
      this.filterData();
    },
    clearFilterData() {
      this.filter.tienda = "";
      this.data = "";
    },
    autorizarLinea(current) {
      let self = this;
      Notifications.alert.confirm(
        "Autorizar Linea",
        "¿Esta seguro de Autorizar Linea?",
        "Si Autorizar",
        function () {
          DynamicService.postAction(
            "wms",
            "facturas",
            current.factura_e,
            "autorizar_linea",
            {
              id: current.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "Autorizar Linea Recepción",
                "Se realizó correctamente"
              );
              $("#modalDetalle").modal("hide");
              self.filterData();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Autorizar Linea Recepción",
                error.response.data.detail
              );
            });
        }
      );
    },
    eliminar_autorizacion(current) {
      let self = this;
      Notifications.alert.confirm(
        "Autorizar Linea",
        "¿eliminar autorizacion?",
        "Si Autorizar",
        function () {
          DynamicService.postAction(
            "wms",
            "facturas",
            current.factura_e,
            "eliminar_autorizacion",
            {
              id: current.id,
            }
          )
            .then((response) => {
              Notifications.alert.success(
                "eliminar autorizacion",
                "Se realizó correctamente"
              );
              $("#modalDetalle").modal("hide");
              self.filterData();
            })
            .catch((error) => {
              Notifications.alert.error(
                "eliminar autorizacion",
                error.response.data.detail
              );
            });
        }
      );
    },
    hide: function () {
      this.$data.destroy();
    },
  },
};
</script>